import React, { useState, useEffect, useRef } from "react";
import { FaPaperclip } from "react-icons/fa";
import bgimage from "../assets/bg.png";
import { LuSendHorizontal } from "react-icons/lu";
const Chatbot = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [socket, setSocket] = useState(null);
  const [isConnecting, setIsConnecting] = useState(false);
  const [threadId, setThreadId] = useState(null);
  const [loading, setLoading] = useState(false); // For general loading
  const [isUploading, setIsUploading] = useState(false); // For file uploading
  const [isSending, setIsSending] = useState(false); // For sending messages
  const messagesEndRef = useRef(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setLoading(true); // Show loading when file is selected
      handleUpload(selectedFile).finally(() => setLoading(false)); // Upload file
    }
  };

  useEffect(() => {
    // Establish WebSocket connection when the component is mounted
    connectWebSocket();

    // Cleanup function
    return () => {
      if (socket) {
        socket.close();
      }
    };
  }, []); // Empty dependency array ensures this runs only once on component mount

  useEffect(() => {
    // Scroll to the bottom of the messages area when messages change
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const connectWebSocket = () => {
    setIsConnecting(true);
    const ws = new WebSocket(`wss://datamini.techdomeaks.com/ws1`);

    ws.onopen = () => {
      setIsConnecting(false);
      setMessages([]);
      addSystemMessage("Only once connected, you can start chatting.");
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        addBotMessage(data.message);
      } catch (error) {
        addBotMessage(event.data);
      }
      setMessages((prev) => prev.filter((msg) => msg.text !== "..."));
      setIsSending(false);
    };

    ws.onclose = () => {
      setIsConnecting(false);
      addSystemMessage("Connection closed. Please refresh to reconnect.");
    };

    ws.onerror = (error) => {
      setIsConnecting(false);
      addSystemMessage("Connection error. Please try again.");
    };

    setSocket(ws); // Store the WebSocket instance
  };

  const addSystemMessage = (text) => {
    setMessages((prev) => [...prev, { sender: "system", text }]);
  };

  const addBotMessage = (text) => {
    setMessages((prev) => [...prev, { sender: "bot", text }]);
  };

  const handleUpload = async (selectedFile) => {
    if (!selectedFile) {
      addSystemMessage("Please select a file first.");
      return;
    }

    setIsUploading(true);

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await fetch(
        "https://datamini.techdomeaks.com/doc-agent",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Upload failed");
      }

      const data = await response.json();

      const threadIdFromServer = data.thread_id;
      setThreadId(threadIdFromServer);

      if (socket && socket.readyState === WebSocket.OPEN) {
        const messageData = {
          message: threadIdFromServer,
        };

        socket.send(JSON.stringify(messageData));
      }
      setMessages([]);
      addSystemMessage(
        `Document uploaded successfully: ${selectedFile.name}. Please ask a question related to this document.`
      );
    } catch (error) {
      addSystemMessage("Failed to upload document. Please try again.");
    } finally {
      setIsUploading(false);
    }
  };

  const sendMessage = (e) => {
    e.preventDefault();

    if (!socket || socket.readyState !== WebSocket.OPEN) {
      addSystemMessage("No connection. Please refresh.");
      return;
    }

    if (!input.trim()) return;

    setIsSending(true); // Show loader while sending message

    const messageData = {
      message: input.trim(),
    };

    socket.send(JSON.stringify(messageData));
    setMessages((prev) => [
      ...prev,
      { sender: "user", text: input.trim() },
      { sender: "system", text: "..." }, // Add loader message
    ]);
    setInput("");
  };

  return (
    <div className="bg-[#f3f4f6] bg-cover bg-center" style={{ backgroundImage: `url(${bgimage})` }}>
      {/* <div
  className="bg-cover bg-center"
  // style={{
  //   backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 250, 0.8), rgba(0, 0, 220, 0.4))',
  // }}
> */}
      <div className="w-[100px] m-6 absolute left-0">
        <img src="datamini.gif" alt="" />
      </div>
      {/* Content goes here */}


      <div className="flex justify-center items-center h-screen">
        <div className="flex w-[50%] h-[80%] text-[#333] relative">
          <div className="mx-auto bg-white rounded-lg shadow-2xl flex flex-col w-full h-full">
            { /* Header */}
            <div className="p-3 bg-gradient-to-r from-[#6B85ED] to-[#2D5288] text-white rounded-t-lg shadow-md">
              <h1 className="font-bold text-lg">
                Tender Summarization Chat Bot
              </h1>
              <p className="mb-2 text-sm ">
                Ask questions or chat about your document
              </p>
            </div>

            {/* Loader */}
            {(isConnecting || loading) && (
              <div className="absolute inset-0 opacity-50 z-50 flex justify-center items-center">
                <div className="animate-spin h-12 w-12 border-4 border-t-transparent border-blue-500 rounded-full"></div>
              </div>
            )}

            {/* Messages Area */}
            <div
              className="flex-1 p-6 overflow-auto space-y-4 bg-gray-50 text-sm"
              id="messages"
            >
              {messages.map((message, index) => (
                <div
                  key={index}
                  className={`flex ${message.sender === "user" ? "justify-end" : "justify-start"
                    }`}
                >
                  <div
                    className={`w-[80%] rounded-lg px-4 py-2 transition duration-200 ease-in-out
                    ${message.sender === "user"
                        ? "bg-custom-blue text-white"
                        : message.sender === "system"
                          ? "bg-gray-200 text-[#0e112d]"
                        : "bg-gray-200 text-[#0e112d]"
                      }`}
                  >
                    {message.text === "..." ? (
                      <div className="loader-dots">
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                      </div>
                    ) : (
                      message.text
                    )}
                  </div>
                </div>
              ))}
              <div ref={messagesEndRef} />
            </div>

            <div className="flex p-2 border-t border-gray-300 bg-grey-200 rounded-lg m-2">
              <div className="flex gap-3 items-center">
                {/* File Upload Button */}

                        <label
                          htmlFor="file-upload"
                          className=" cursor-pointer relative group flex items-center justify-center h-9 w-11  rounded-lg bg-gray-200 transition-colors mr-2"
                        >
                          <FaPaperclip className="h-5 w-5 text-custom-color" />
                          {/* Tooltip for File Upload */}
                          <div className="absolute -top-9 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity">
                          Upload File
                          </div>
                        </label>

                        <input
                          id="file-upload"
                          type="file"
                          onChange={handleFileChange}
                          className="hidden"
                          accept=".pdf,.txt,.doc,.docx"
                        />
                        </div>

                        {/* Chat Input */}
              <form onSubmit={sendMessage} className="flex w-full">
                <input
                  type="text"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  placeholder={
                    threadId
                      ? "Type your message..."
                      : "Upload a document to start chatting"
                  }
                  className="flex-1 px-4 py-2 border rounded-lg bg-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-300 text-sm"
                  disabled={!threadId || isConnecting || isUploading || isSending} // Disable input while sending
                />
                <button
                  type="submit"
                  disabled={
                    !threadId || !input.trim() || isConnecting || isUploading || isSending
                  }
                  className={`ml-2 px-6 py-2 bg-gray-200 rounded-lg transition text-sm disabled:opacity-50 ${!threadId || !input.trim() || isConnecting || isUploading || isSending
                      ? 'cursor-not-allowed'
                      : ''
                    }`}
                >
                  {isSending ? (
                    <div className="animate-spin h-5 w-5 border-2 border-t-transparent border-white rounded-full"></div> // Show loader inside button
                  ) : (
                    <LuSendHorizontal className="h-5 w-5 text-custom-color" />
                  )}
                </button>

              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chatbot;